/**
 * C5, the host role: the server elects one host per user from the tabs' candidate reports
 * (candidate.ts, apps.sandbox.routing) and tells every tab its part in a `sandbox.host` frame. The
 * host tab runs the user's sandbox work; standby tabs do not; with no candidate it runs hosted.
 */
import type { Frames } from "../../protocol/protocol";

export type SandboxHost = Frames["sandbox.host"];
export type SandboxHostRole = SandboxHost["role"];
export type SandboxHostKind = SandboxHost["kind"];

/**
 * Whether `next` replaces the held role: a later epoch does (frames from before a change can arrive
 * late, and one epoch gives a tab one part, so a repeat changes nothing). So does a frame of the
 * same epoch whose `served` differs: `served` follows SANDBOX_HOSTED_EXECUTOR, not the election, so
 * a deploy that turns it on or off re-announces the same epoch (a hello, a retried announcement).
 */
export function newerHost(held: SandboxHost | null, next: SandboxHost): boolean {
  if (held === null || next.epoch > held.epoch) return true;
  return next.epoch === held.epoch && !!next.served !== !!held.served;
}
